import styles from './FJServerBusyModal.module.less';
import ServerBusyPng from '../../../assets/base64/server-busy.js';
import ServerBusyMobilePng from '../../../assets/base64/server-busy-mobile.js';
import FJLocalStore from '../../../store/FJLocalStore.js';
import CloseIcon from '../../../assets/svg/mobile-close.svg?react';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton.jsx';
import FlashUpgradeSvg from '../../../assets/svg/flash-upgrade.svg?react';
import FJModalClose from '../FJModalClose/FJModalClose.jsx';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil.js';

const FJServerBusyModal = ({ onClose, isMobile, onUpgrade, hasDiscount }) => {
    return (
        <div className={classNames(styles.container, isMobile ? styles.mobile : '')}>
            {isMobile ? (
                <div className={styles.close} onClick={onClose}>
                    <CloseIcon />
                </div>
            ) : (
                <FJModalClose onClick={onClose} />
            )}

            {isMobile ? (
                <img src={ServerBusyMobilePng} className={styles.img} alt='server-busy' />
            ) : (
                <img src={ServerBusyPng} className={styles.img} alt='server-busy' />
            )}

            <div className={styles.title}>{FJLocalStore._('server-is-busy-with-many-tasks')}</div>
            <div
                className={styles.desc}
                dangerouslySetInnerHTML={{
                    __html:
                        !hasDiscount || FJUtil.getAB() === 'A'
                            ? FJLocalStore._('please-try-again-later-1')
                            : FJLocalStore._('please-try-again-later'),
                }}
            />

            <FJButton
                className={styles.btn}
                type={FJButtonType.RED_BLUE_GRADIENT}
                text={FJLocalStore._('get-now')}
                textClassName={styles.btnText}
                icon={<FlashUpgradeSvg />}
                onClick={onUpgrade}
            />
        </div>
    );
};

FJServerBusyModal.propTypes = {
    onClose: PropTypes.func,
    isMobile: PropTypes.bool,
    onUpgrade: PropTypes.func,
    hasDiscount: PropTypes.bool,
};

export default FJServerBusyModal;
